import axios from "axios";

// const BASE_URL = 'http://localhost:8100/api/v1'
// const BASE_URL = 'http://61.92.126.191:8101/api/v1'
// const BASE_URL = 'https://wellful.loca.lt/api/v1'
// const BASE_URL = 'http://admin-portal-bff.34.92.190.29.nip.io/api/v1'
// const BASE_URL = 'https://bsm-mobile-bff.recday.synology.me/api/v1'
const BASE_URL = 'https://ibsm-api.viteg.net/api/v1'


export default axios.create({
    baseURL: BASE_URL
})